import axios from '../../config/axios';
import config from '../../config/api';
import { setSnackbar } from './SnackbarAction';

export const getDisputeData = (data) => ({
    type: 'GET_DISPUTE',
    data
})

export const getAllDisputes = (data) => ({
    type: 'GET_ALL_DISPUTES',
    data
})

export const getDisputeJournalData = (data) => ({
    type: 'GET_DISPUTE_JOURNAL',
    data
})

export const getFilteredData = (data) => ({
    type: 'FILTER_DISPUTES',
    data
})

export const setEdited = (data) => ({
    type: 'SET_EDIT',
    data
})

export const setModified = (data) => ({
    type: 'SET_MODIFIED',
    data
})

export const setDisputeID = (data) => ({
    type: 'SET_DISPUTEID',
    data
})


export const fetchDispute = (disputeID) => {

    return function (dispatch) {
        axios.get(`${config.api.FETCH_URL}/disputes/getDispute/${disputeID}`).then(response => {
            if (response.status === 200) {
                dispatch(getDisputeData(response.data));
            } else {
                dispatch(getDisputeData([]));
            }
        }).catch(error => {
            dispatch(getDisputeData([]));
            dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
        })
    }
}
export const fetchAllDisputes = () => {

    return function (dispatch) {
        axios.get(`${config.api.FETCH_URL}/disputes/getAllDisputes`).then(response => {
            if (response.status === 200) {
                dispatch(getAllDisputes(response.data));
            } else {
                dispatch(getAllDisputes([]));
            }
        }).catch(error => {
            dispatch(getAllDisputes([]));
            dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
        })
    }
}

export const fetchJournalTransactions = (disputeID) => {
    return function (dispatch) {
        axios.get(`${config.api.FETCH_URL}/disputes/getJournal/${disputeID}`).then(response => {
            if (response.status === 200) {
                dispatch(getDisputeJournalData(response.data));
            } else {
                dispatch(getDisputeJournalData([]));
            }
        }).catch(error => {
            dispatch(getDisputeJournalData([]));
            dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
        })
    }
}

export const addDispute = (body) => {
    return function (dispatch) {
        axios.post(`${config.api.FETCH_URL}/disputes/addDispute`, body).then(response => {
            if (response.status === 201) {
                dispatch(setDisputeID(response.data.disputeID))
                dispatch(setSnackbar(true, 'success', 'Dispute Added Successfully'))
                dispatch(setModified(true))
            } else {
                dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
        })
    }
}

export const editDispute = (body) => {
    return function (dispatch) {
        axios.put(`${config.api.FETCH_URL}/disputes/updateDispute`, body).then(response => {
            if (response.status === 200) {
                dispatch(setDisputeID(response.data.disputeID))
                dispatch(setSnackbar(true, 'success', 'Dispute Edited Successfully'))
                dispatch(setModified(true))
            } else {
                dispatch(setSnackbar(true, 'error', 'ISO Not Modified'))
            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
        })
    }
}

export const filteredData = (data) => {
    return function (dispatch) {
        dispatch(getFilteredData(data))
    }
}

